
import { Tag } from "lucide-react";

function OfferBar({ text, textShort, claimBy, daysLabel, link, href }) {
  return (
    <div className="bg-charcoal text-on-dark">
      <p className="mx-auto flex min-h-10 max-w-[1140px] items-center justify-center gap-x-2 px-4 py-1.5 text-center text-xs sm:text-sm">
        <Tag
          className="size-3.5 shrink-0 text-brand-bright"
          aria-hidden="true"
        />

        <span className="sm:hidden">{textShort}</span>

        <span className="max-sm:hidden">
          {text}  {/*{claimBy}*/}
        </span>

        <span aria-hidden="true">·</span>

          {/*<span className="font-semibold text-brand-bright">
        {daysLabel}
        </span>*/}

        <a
          href={href}
          className="ml-1 font-semibold text-white underline underline-offset-2"
        >
          {link}
        </a>
      </p>
    </div>
  );
}

export default OfferBar;
